import { put, call, takeLatest, debounce, fork } from "redux-saga/effects";
import { showErrorToast } from "util/toastUtils";
import {
    eodDailySummarySuccess,
    eodDailySummaryFailure,
} from "./eodReportsActions";
import {
    EOD_DAILY_SUMMARY_REQUEST,
} from "./eodReportsConstants";
import {
    getEodDailySummary,
} from "./eodReportsApi";
import { decryptJson } from "util/react-ec-utils";

// Live Check-in Sagas
export function* eodDailySummarySaga(action) {
    try {
        const response = yield call(getEodDailySummary, action.payload);
        const decryptedData = decryptJson(response?.data?.encryptedText)
        if (response.status === 200) {        
            yield put(eodDailySummarySuccess(decryptedData));
        } else {
            yield put(eodDailySummaryFailure(decryptedData?.message));
            showErrorToast(decryptedData?.message);
        }
    } catch (error) {
        yield put(eodDailySummaryFailure(error));
    }
}

export default function* eodSaga() {
    yield takeLatest(EOD_DAILY_SUMMARY_REQUEST, eodDailySummarySaga);

}